// Used in many components

// Angular
import { Component, OnInit, Input } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";

// Components
import { GenericDialogComponent } from "#components/dialog-boxes/generic-dialog/generic-dialog.component";

@Component({
    selector: "section-label",
    templateUrl: "./section-label.component.html",
    styleUrls: ["./section-label.component.scss"],
    standalone: false
})
export class SectionLabelComponent implements OnInit {
    genericDialogRef: MatDialogRef<GenericDialogComponent> | null;
    @Input() sectionLabelContent: any;
    @Input() alignCenter?: boolean;
    @Input() isTeacher = true;

    constructor(public dialog: MatDialog) {}

    ngOnInit() {}

    openGenericDialog() {
        this.genericDialogRef = this.dialog.open(GenericDialogComponent, {
            data: {
                genericTitle: this.sectionLabelContent.infoTitle,
                genericContent: this.sectionLabelContent.infoContent,
            },
        });
    }
}
